export class User {
    salutationId: string;
    firstName: string;
    middleName:string;
    lastName: string;
    nickName: string;
    email: string;
    jobTitleId: string;
    lineOfBusinessId: string;
    geographicResponsibilityId:string;
    organizationId: string;
    biography: string;
    isActive: string;
    profileUrl: string;
    token:string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/user.ts